import React from "react";
import { YMaps, Map, Placemark, Clusterer } from "react-yandex-maps";
import { addresses as points } from "./data";
import { last_addresses as points2 } from "./data/last_data";
import "./Location.scss";

const mapState = {
  center: [55.751574, 37.573856],
  zoom: 9,
  behaviors: ["default", "scrollZoom"],
};

const Location = () => {
  const getPointData = (place, idx) => {
    return {
      balloonContentHeader: place.title,
      balloonContentBody: place.title,
      clusterCaption: place.desc,
    };
  };

  const getPointOptions = (color) => {
    return {
      preset: `islands#${color}Icon`,
    };
  };
  return (
    <section className="location" id="location">
      <div className="container">
        <div className="location-wrapper">
          <h2 className="section-title location__title">Точки сбора щеток</h2>
          {points && (
            <YMaps>
              <Map
                width="750px"
                height="600px"
                modules={["package.full"]}
                state={mapState}
                className="location__map"
                id="map"
              >
                <Clusterer
                  options={{
                    preset: "islands#invertedRedClusterIcons",
                    groupByCoordinates: false,
                    clusterDisableClickZoom: true,
                    clusterHideIconOnBalloonOpen: false,
                    geoObjectHideIconOnBalloonOpen: false,
                  }}
                >
                  {points.map((place, idx) => (
                    <Placemark
                      key={idx}
                      geometry={place.coord}
                      properties={getPointData(place, idx)}
                      options={getPointOptions("red")}
                    />
                  ))}
                  {points2.map((place, idx) => (
                    <Placemark
                      key={idx}
                      geometry={place.coord}
                      properties={getPointData(place, idx)}
                      options={getPointOptions("blue")}
                    />
                  ))}
                </Clusterer>
                <Clusterer
                  options={{
                    preset: "islands#invertedBlueClusterIcons",
                    groupByCoordinates: false,
                    clusterDisableClickZoom: true,
                    clusterHideIconOnBalloonOpen: false,
                    geoObjectHideIconOnBalloonOpen: false,
                  }}
                >
                  
                  {points2.map((place, idx) => (
                    <Placemark
                      key={idx}
                      geometry={place.coord}
                      properties={getPointData(place, idx)}
                      options={getPointOptions("blue")}
                    />
                  ))}
                </Clusterer>
              </Map>
            </YMaps>
          )}
        </div>
      </div>
    </section>
  );
};

export default Location;
